/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Ledger_Note_Sync_FailedInputs */

const vi_error_ledger_note_sync_failed = /** @type {(inputs: Error_Ledger_Note_Sync_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không sửa được phiếu nhập kho theo dòng sổ nên dòng sổ chưa được lưu. Tải lại trang, mở phiếu kiểm tra rồi sửa lại sổ.`)
};

/**

* @param {Error_Ledger_Note_Sync_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_ledger_note_sync_failed = /** @type {((inputs?: Error_Ledger_Note_Sync_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Ledger_Note_Sync_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_ledger_note_sync_failed(inputs)
});